import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal } from '../../../store/reducers/modal/modal.slice'

const Modal = () => {
  const dispatch = useDispatch()
  const modal = useSelector((state: any) => state.modal)

  return (
    <Dialog
      open={modal.isOpen}
      onClose={() => dispatch(closeModal())}
      maxWidth="sm"
      PaperProps={{
        style: {
          width: modal.width ? `${modal.width}px` : '850px',
          maxWidth: '90%',
        },
      }}
    >
      <DialogTitle>{modal.title}</DialogTitle>
      <DialogContent>{modal.content}</DialogContent>
    </Dialog>
  )
}

export default Modal
